import React from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Badge from "../Badges/Badge";
import Avatar from "@mui/material/Avatar";
import _ from "lodash";
import { getCaseLink, isContractProduct } from "../../services/Product/ProductService/productService";
import { Link } from "react-router-dom";
import { getBadgeContent, getLabelFromHit } from "../../services/Board/algolia";
import { translate } from "../../services/Translations/translatorService";
import { BackofficeUser } from "../../types/BackofficeUser";
import { CaseHit } from "../Case/CaseEntityPicker/Hit/hitType";
import { Theme, Tooltip, useTheme } from "@mui/material";
import { ArrowUpwardOutlined } from "@mui/icons-material";

const boardCardStyles = {
  avatar: {
    backgroundColor: "#a1ccca",
    marginRight: "0.2rem",
    width: "2rem",
    height: "2rem",
    position: "static",
  },
  boardCardContainer: (theme: Theme)=> ({
    textDecoration: "none",
    color: theme.palette.text.primary,
  }),
  card: {
    textAlign: "left",
    minWidth: 150,
    maxWidth: 600,
    marginTop: "1rem",
    padding: "0.5rem",
  },
  name: {
    fontSize: "14px",
    fontWeight: 500,
    wordWrap: "break-word",
    marginBottom: "10px",
  },
  caseCategory: {
    marginTop: "10px",
  },
  activity: {
    textAlign: "right",
  },
  won: {
    border: "2px solid #009640",
  },
  lost: {
    border: "2px solid #e30613",
  },
  inactive: {
    border: "2px solid #ff9600",
  },
  open: {},
};
type BoardCardProps = {
  hit: CaseHit;
  backofficeUsers: BackofficeUser[];
};
const BoardCard = ({ hit, backofficeUsers }: BoardCardProps) => {
  const selectedAccountManager = _.find(backofficeUsers, (user) => {
    return user.id === hit.accountManager;
  });
  const selectedLawyer = _.find(backofficeUsers, (user) => {
    return user.id === hit.responsibleLawyer;
  });

  return (
    <Paper sx={[boardCardStyles.card, boardCardStyles[hit.caseType]]}>
      <Grid
        component={Link}
        to={getCaseLink({ productClassName: hit.product, id: hit.productId })}
        sx={boardCardStyles.boardCardContainer}
        container
      >
        <Grid size={10} sx={boardCardStyles.name}>
          {getLabelFromHit(hit)}
        </Grid>
        <Grid size={2} sx={boardCardStyles.activity}>
          {hit.isHigherInstanceCase && (
            <Tooltip title="Höhere Instanz">
              <ArrowUpwardOutlined />
            </Tooltip>
          )}
        </Grid>
        <Grid size={5}>
          <Badge text={getBadgeContent(hit)} size={"small"} />
        </Grid>
        <Grid size={7}>
          <Grid
            container
            wrap={"nowrap"}
            sx={{
              justifyContent: "flex-end",
            }}
          >
            <Grid>
              {selectedAccountManager && (
                <Avatar src={selectedAccountManager.avatar || undefined} sx={boardCardStyles.avatar}>
                  {selectedAccountManager.person.givenName.charAt(0) +
                    selectedAccountManager.person.familyName.charAt(0)}
                </Avatar>
              )}
            </Grid>
            <Grid>
              {selectedLawyer && (
                <Avatar src={selectedLawyer.avatar || undefined} sx={boardCardStyles.avatar}>
                  {selectedLawyer.person.givenName.charAt(0) + selectedLawyer.person.familyName.charAt(0)}
                </Avatar>
              )}
            </Grid>
          </Grid>
        </Grid>
        {(isContractProduct(hit.product) ||
          hit.product === "generalCivilLaw" ||
          hit.product === "employmentContract" ||
          hit.product === "civilServiceLaw") && (
          <Grid sx={boardCardStyles.caseCategory} size={12}>
            <Badge
              text={translate(hit.product + ".caseCategory.values." + hit.caseCategory, "Noch nicht gesetzt")}
              size={"small"}
            />
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};

export default BoardCard;
